<template>
    <div class="address-wrap">
        <van-nav-bar
            title="收货地址管理"
            left-arrow
            @click-left="$router.back()"
        ></van-nav-bar>
        <view-body :list="addressList"></view-body>
        <van-button
            type="primary" block
            color="#EB5435"
            size="large"
            @click="$router.push('/addressDetail')"
            class="address-wrap-ft">新增收货地址</van-button>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import ViewBody from './ViewBody';
export default {
    components: {
        ViewBody
    },
    computed: {
        ...mapState('address', {
            addressList: 'addressList'
        })
    },
    methods: {
        ...mapActions('address', {
            getAddressList: 'getAddressListAction',
            deleteAddress: 'deleteAddressAction',
            setDefaultAddress: 'setDefaultAddressAction'
        })
    },
    created() {
        this.getAddressList();
    }
};
</script>
<style lang="scss" scoped>
.address-wrap {
    position: relative;
    display: flex;
    height: 100%;
    box-sizing: border-box;
    flex-direction: column;
    padding-bottom: 50px;

    .van-nav-bar .van-icon {
        color: #000000;
    }
    .van-nav-bar__title {
        color: #000000;
        font-size: 18px;
        font-weight: bold;
    }
    .address-wrap-ft {
        position: fixed;
        bottom: 0;
        left: 0;
    }
}
</style>